// カラーミーショップのアプリを追加した店主が、HINOMEアカウントを作る（または
// ログインする）まで持ち回る「後で紐付ける約束」。
//
// アプリを追加した直後の店主に、マイページを自力で探させないための仕掛け。
// sessionStorage に置くのは、タブを閉じたら忘れてよい一時的な情報だから。
const KEY = "colorme_pending_link";

export type ColormePendingLink = {
  // 対象ショップ（PA+8桁）
  shopId: string;
  // 店主が見慣れた表示名（画面の文言に使う）
  shopLabel?: string;
  // カラーミーショップの認証が済んでいれば入る。これがあれば認証をやり直さない
  linkTicket?: string;
  // カラーミーショップ限定プランの契約が有効か
  hasContract?: boolean;
};

export const saveColormePendingLink = (value: ColormePendingLink): void => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // プライベートモード等で保存できなくても、通常の連携手順は残っているので黙って諦める
  }
};

export const readColormePendingLink = (): ColormePendingLink | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.shopId ? (parsed as ColormePendingLink) : null;
  } catch {
    return null;
  }
};

export const clearColormePendingLink = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // 消せなくても実害はない
  }
};
